import React, { useEffect, useState } from "react";
import * as Device from "expo-device";

export type DeviceType = "PHONE" | "TABLET" | "DESKTOP" | "TV" | "UNKNOWN";

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState<DeviceType>("UNKNOWN");

  const getDeviceType = async () => {
    Device.getDeviceTypeAsync().then((d) => {
      const device = Device.DeviceType[d] as DeviceType;
      console.log("This is running on a", device);
      setDeviceType(device);
    });
  };

  useEffect(() => {
    getDeviceType();
  }, []);

  return {
    deviceType,
  };
};

export default useDeviceType;
